import { FC } from 'react';
import { Props } from './types';
import { TextAreaStyled } from './style';

const autoSizeDefault = { minRows: 3, maxRows: 5 };

const TextArea: FC<Props> = ({ palette, design, size, autoSize = autoSizeDefault, value = '', placeholder, name, disabled, onChange, prefixCls = 'textarea', ...props }) => (
  <TextAreaStyled
    palette={palette}
    design={design}
    xsize={size}
    autoSize={autoSize}
    value={value}
    placeholder={placeholder}
    name={name}
    disabled={disabled}
    onChange={onChange}
    prefixCls={prefixCls}
    {...props}
  />
);

export default TextArea;
